import React from 'react'

const LearningExperience = () => {
  return (
    <div>
      <h1>LearningExperience Component</h1>
    </div>
  )
}

export default LearningExperience
